// extracted by mini-css-extract-plugin
module.exports = {"text-block":"TextBlock-module--text-block--2piCT","textBlock":"TextBlock-module--text-block--2piCT","headline":"TextBlock-module--headline--3lTST"};